export default "__VITE_ASSET__DPFyoAOe__"